import { ErrorMessage, Field, Form, Formik } from "formik";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from '../assets/img/logo.png'
import FormValues from "../interfaces/loginForm";

const Login = () => {

  const navigate = useNavigate();

  const initialValues: FormValues = {
    name: '',
    email: '',
  };


  const [form] = useState({
    username: "",
    password: "",
  });

  const handleSubmit = async (values: FormValues) => {
    // try {
    //   const { data } = await axios.post(process.env.REACT_APP_BACK_URL + '/admin/login', formData);
      console.log('values', values)
      localStorage.setItem("isLoggedIn", "true");
      navigate('/');

    // } catch (err) {
    //   console.log(err.response.data)
    // }
  };

  return (
    <div className="row vh-100 bg-colored">
      {/* <div className="background-container col-lg-8 d-none d-lg-block">
        <img src={background} className="background" alt="background"></img>
      </div> */}
      <div className="col-12 d-flex align-items-center">
        <div className="container p-4">
          <div className="row justify-content-center">
            <div className="col-6 justify-content-center d-grid">
              <div className="d-flex justify-content-center">
                <img
                  src={logo}
                  alt="logo"
                  style={{ maxWidth: "350px", padding: "20px" }}
                />
              </div>
              <Formik initialValues={initialValues} onSubmit={handleSubmit}>
                <Form>
                  <div className="mb-3 form-group">
                    <label htmlFor="username">
                      Usuario <sup>*</sup>{" "}
                    </label>
                    <Field
                      type="text"
                      name="username"
                      id="username"
                      className="form-control"
                      placeholder="Ingresa tu usuario"
                      maxLength={60}
                    />
                    <ErrorMessage name="username" component="div" />
                  </div>
                  <div className="mb-3 form-group">
                    <label htmlFor="pass">
                      Contraseña <sup>*</sup>{" "}
                    </label>
                    <Field
                      type="password"
                      name="password"
                      id="password"
                      className="form-control"
                      placeholder="Ingresa tu contraseña"
                      maxLength={15}
                    />
                    <ErrorMessage name="password" component="div" />
                  </div>
                  <div id="error" className="error-message"></div>
                  <div className="d-grid">
                    <button type="submit" className="btn-primary-custom btn">
                      Ingresar
                    </button>
                  </div>
                </Form>
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
